(function(angular){
	'use strict';
	
	angular.module('slideModule', ['BaseConfig']);

})(window.angular);